import { render, staticRenderFns } from "./SalaryImportDetailModal.vue?vue&type=template&id=1316dc42&scoped=true"
import script from "./SalaryImportDetailModal.vue?vue&type=script&lang=js"
export * from "./SalaryImportDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SalaryImportDetailModal.vue?vue&type=style&index=0&id=1316dc42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1316dc42",
  null
  
)

export default component.exports